/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useRef, useEffect} from 'react'
import {initialQueryState, KTSVG} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const ListSearchComponent = () => {
  const {updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSearch = () => {
    if (inputRef.current) {
      const newSearchTerm = inputRef.current.value
      updateState({searchTerm: newSearchTerm, ...initialQueryState})
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '') {
      handleSearch()
    }
  }

  useEffect(() => {
    if (searchTerm === '') {
      updateState({searchTerm: '', ...initialQueryState})
    }
  }, [searchTerm])

  return (
    <div className='card-title'>
      {/* begin::Search */}
      <div className='d-flex align-items-center position-relative my-1'>
        <input
          ref={inputRef}
          type='text'
          data-kt-user-table-filter='search'
          className='form-control form-control-white form-control-sm w-250px custom-search-radius'
          placeholder='Search IVR Numbers'
          onKeyDown={handleKeyDown}
          onChange={handleOnChange}
        />
        <button
          type='button'
          className='btn btn-primary btn-sm custom-search-btn-radius btn-icon px-4'
          onClick={handleSearch}
        >
          <KTSVG path='/media/icons/duotune/general/gen021.svg' className='' />
        </button>
      </div>
      {/* end::Search */}
    </div>
  )
}

export {ListSearchComponent}
